<fgb-mobile-header-bar [title]="'acejump.page.title' | translate" [showPoints]="true" [link]="'/games'"></fgb-mobile-header-bar>
<div
  class="game-layout-banner"
  [ngClass]="{
    'leaderboard-enabled': isLeaderboardEnabled,
    'pb-lg-0': isLeaderboardEnabled,
  }"
>
  <div class="container" fgbAnimateOnScroll>
    <a class="games-back-btn d-lg-flex d-none text-white" [routerLink]="['/games']">
      <i class="material-icons">chevron_left</i>
      <span>{{ 'games.back.button' | translate }}</span>
    </a>
    <div class="game-banner-img">
      @if (isLeaderboard) {
        <img src="assets/images/games/leaderboard.png" alt="" />
      } @else {
        <img src="assets/images/games/AceJumpBanner.jpg" alt="" />
      }
    </div>
    @if(isLeaderboardEnabled){
    <div class="pt-lg-3 pt-2 pb-3 pb-lg-0">
      <fgb-route-nav>
        <a
          class="nav-item"
          [routerLink]="['/games/acejump']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <label>{{ 'acejump.nav.play' | translate }}</label>
        </a>
        <a
          class="nav-item"
          [routerLink]="['/games/acejump/leaderboard']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <label>{{ 'acejump.nav.leaderboard' | translate }}</label>
        </a>
      </fgb-route-nav>
    </div>
    }
  </div>
</div>

<div class="mobile-content-wrapper">
  <router-outlet></router-outlet>
</div>
